import {MenuItem} from '@/components/ui/menu-atoms/MenuAtoms.tsx'
import {CheckIcon} from '@/components/ui/icon/Icon.tsx'
import {Spinner} from '@/components/ui/spinner/Spinner'
import {useTranslation} from '@/translations/i18n.tsx'
import {Access} from '../../types'
import {useValidateAccesses} from '../../queries/useValidateAccesses'
import {MUTATION_KEYS} from '@/queryClient'
import {toast} from '@/utilities/toast/toast'
import {useMutationState} from '@tanstack/react-query'
import {HttpValidateAccessesOptions} from '../../http/accesses.http'

export const ValidateAccessButton = ({access}: {access: Access}) => {
    const {t} = useTranslation()
    const {mutate: validateAccess, isPending: isValidating} = useValidateAccesses({
        onSuccess: () => {
            toast.success(t('accesses:access_validated_success', {count: 1}))
        }
    })
    const validatingAccessesMutation = useMutationState({
        filters: {
            mutationKey: [MUTATION_KEYS.VALIDATE_ACCESS],
            status: 'pending'
        },
        select: mutation => mutation.state.variables as HttpValidateAccessesOptions['payload']
    })

    return (
        <MenuItem
            hideOnClick={false}
            disabled={
                isValidating || validatingAccessesMutation.some(mutation => mutation.accessIds.includes(access.id))
            }
            onClick={e => {
                e.stopPropagation()
                e.preventDefault()
                validateAccess({accessIds: [access.id]})
            }}
        >
            {isValidating ? <Spinner /> : <CheckIcon />}
            {t('accesses:validate_access', {count: 1})}
        </MenuItem>
    )
}
